import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    quote: 'Vivía encerrada por mis miedos. Con el Método Integra los dejé atrás rápido y sin sufrir. Hoy soy otra persona.',
    author: 'María Fernanda Ojeda',
    photo: 'https://cdn.magicpatterns.com/uploads/2zmQSpwAyYx9uxj89pAXSN/WhatsApp_Image_2026-04-11_at_18.38.56.jpg'
  }, {
    quote: 'Sanar a distancia fue increíblemente fácil. Me devolvió la paz que necesitaba tras el duelo por mi padre.',
    author: 'Gabriel Sánchez',
    photo: 'https://cdn.magicpatterns.com/uploads/9njFeyK2PTwpa9dpLu3qbj/WhatsApp_Image_2026-04-11_at_18.38.59.jpg'
  }, {
    quote: 'Mi cuerpo reaccionó cuando cambié mi mente. Recuperé mi vitalidad y mi energía. ¡Me siento mejor que nunca!',
    author: 'Fernando Calderón',
    photo: 'https://cdn.magicpatterns.com/uploads/cs6KxNABja8Z4AiK6peedR/WhatsApp_Image_2026-04-11_at_18.38.58.jpg'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="testimonials" className="py-24 bg-white" data-id="element-128">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4" data-id="element-131">
            Resultados Reales
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-132"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-133">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} variants={cardVariants} className="bg-soft/20 p-8 md:p-10 rounded-3xl relative border border-soft/30 hover:shadow-lg transition-shadow" data-id="element-134">
              <QuoteIcon className="w-12 h-12 text-accent/30 absolute top-6 left-6" data-id="element-135" />
              <div className="relative z-10 pt-8" data-id="element-136">
                <p className="text-lg md:text-xl text-primary font-medium italic mb-8 leading-relaxed" data-id="element-137">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-138">
                  <img src={testimonial.photo} alt={testimonial.author} className="w-14 h-14 rounded-full object-cover border-2 border-accent/30" data-id="element-139" />
                  <p className="font-bold text-primary" data-id="element-140">{testimonial.author}</p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};